// extracted by mini-css-extract-plugin
export default {"wrapper":"CRMLevelPage_wrapper__Xk8BI"};